<template>
  <v-btn
    class="ma-3 btn-border"
    color="white"
    :width="width"
    :height="height"
    :disabled="isDisabled"
    link
    :to="to"
    v-if="visible"
  >
    <span>
      <img :src="iconSrc" :alt="altText" class="image-style" />
      <div :style="{ fontSize: labelFontSize }" class="mt-2">{{ label }}</div>
    </span>
  </v-btn>
</template>

<script>
export default {
  props: {
    iconSrc: String,
    label: String,
    to: Object,
    width: {
      type: String,
      default: '190px',
    },
    height: {
      type: String,
      default: '190px',
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    visible: {
      type: Boolean,
      default: true,
    },
    altText: {
      type: String,
      default: 'icon',
    },
    labelFontSize: {
      type: String,
      default: '16px',
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-border {
  border-radius: 20px !important;
}

.image-style {
  display: block;
  margin: auto;
  // Fixed 60px box (not just a max cap) so tiles whose source icon is
  // intrinsically smaller — e.g. icon_menu_ecommerce.svg is 22×22, reused
  // from the sidebar — scale up to match their 60×60 peers instead of
  // rendering tiny. object-fit: contain keeps aspect ratio, so non-square
  // icons letterbox rather than distort.
  width: 60px;
  height: 60px;
  object-fit: contain;
}
</style>
